import roadmap from "./roadmap";
const {ccclass, property} = cc._decorator;
@ccclass
export default class bjlRoadmap extends roadmap {


    onRefreshDisplay(roadList, mapType = null){
        this.roadList = roadList? roadList:this.roadList
        let roadList_show1 = this.disposeData(1)
        this.bigRoad = []
        if(mapType != null){
            this.reset(mapType)
            
            switch(mapType){
                case 0:
                    this.showRoadMap1()
                    break
                case 1:
                    this.showRoadMap2(false,roadList_show1,false)
                    break
                case 2:
                    this.showRoadMap2(true,roadList_show1,false)
                    this.showRoadMap3(0)
                    break
                case 3:
                    this.showRoadMap2(true,roadList_show1,false)
                    this.showRoadMap3(1)
                    break
                case 4:
                    this.showRoadMap2(true,roadList_show1,false)
                    this.showRoadMap3(2)
                    break
                default:
                    break       
            }
        }else{
            for(let i=0;i< this.mapNode.length; i++){
                this.reset(i)
            }
            this.showRoadMap1()
            this.showRoadMap2(false,roadList_show1,false)
            this.showRoadMap3(0)
            this.showRoadMap3(1)
            this.showRoadMap3(2)
        }
    }
    
    
    //珠盘路
    showRoadMap1(){
        let tempList = []
        tempList = tempList.concat(this.roadList)
        let row = parseInt(String(tempList.length/this.showMaxHan))  
        if(tempList.length%this.showMaxHan != 0){
            row = row +1
        }
        let deleteRow = row -  this.zhuPanLu.showMaxRow
        if (deleteRow > 0) {
            for(let i = 0 ; i < deleteRow; i ++){
                for(let j = 0; j < this.showMaxHan ;j ++){
                    tempList.shift()
                }
            }
        }
        for(let i = 0; i< tempList.length;i++){
            this.creatorSprite(this.getByKey(tempList[i]),0 , new cc.Vec2(parseInt(String(i/this.showMaxHan)) * this.zhuPanLu.spacing.x, i%this.showMaxHan * - this.zhuPanLu.spacing.y ), this.zhuPanLu.size)
        }
    }

    //大路
    showRoadMap2(isOnlyRefreshData:boolean = false, roadList, getlastValus:boolean = false){
        if (cc.isValid(this.mapNode[1])){
            this.mapNode[1].active = !isOnlyRefreshData
        }
        this.bigRoad = []
        let row = -1 //列
        let displayRow = 0
        let displayCon = 0
        let maxDisplayCon = 0
        let road = null
        let lastRoad = null
        let tmp = null
        let bigRoadDisplay:any[] = []
        let oneRoundHe = null
        for(let i = 0; i< roadList.length;i++){
            road = roadList[i].result
            if(road == 3){
                if (i != 0){
                    let count = 1 //连续 “和”的次数
                    let temp_i = i
                    while(temp_i > 0 && roadList[temp_i-1].result == 3 ){
                        count = count +1
                        temp_i = temp_i -1
                        if(temp_i-1 == 0 || (temp_i > 0 && roadList[temp_i-1].result != 3 )){
                            break
                        }
                    }
                    if(oneRoundHe != null){
                        oneRoundHe = count
                    }else{
                        if(bigRoadDisplay[displayRow][displayCon]){
                            bigRoadDisplay[displayRow][displayCon][1] =count+""
                        }
                    }
                }else{
                    oneRoundHe = 1//this.creatorLabel(this.mapNode[1], "1", 30,null)
                }
                continue
            }
          
            if( road != lastRoad){
                row = row +1
                maxDisplayCon =this.showMaxHan
            }
            if(this.bigRoad[row] == null ){
                this.bigRoad[row] = []
            }
            

            displayRow = (this.bigRoad[row].length > maxDisplayCon ? this.bigRoad[row].length - maxDisplayCon : 0) + this.bigRoad.length -1
            displayCon = this.bigRoad[row].length > maxDisplayCon ? maxDisplayCon : this.bigRoad[row].length
           
            if(bigRoadDisplay[displayRow] == null){
                bigRoadDisplay[displayRow] = []
            }else {
                while(bigRoadDisplay[displayRow][displayCon] != null ||(road == lastRoad && this.bigRoad[row].length >= this.showMaxHan)){
                    displayCon = displayCon -1  
                    displayRow = displayRow +1
                    if(bigRoadDisplay[displayRow] == null){
                        bigRoadDisplay[displayRow] = []
                    }
                   
                    if(bigRoadDisplay[displayRow][displayCon] == null){
                        if(maxDisplayCon == this.showMaxHan){
                            maxDisplayCon = displayCon
                        }

                        break
                    }
                }
            }

            
            this.bigRoad[row][ this.bigRoad[row].length ] = roadList[i]
            if(oneRoundHe != null){
                bigRoadDisplay[displayRow][displayCon] = [roadList[i].result, oneRoundHe +"" ]
                oneRoundHe = null
            }else{
                bigRoadDisplay[displayRow][displayCon] = [roadList[i].result ]
            }
            lastRoad = road
        }

        if( bigRoadDisplay.length> this.daLu.showMaxRow){
            let needDeleteNum = bigRoadDisplay.length - this.daLu.showMaxRow
            for(let i =0;i<needDeleteNum; i++){
                bigRoadDisplay.shift()
                // this.bigRoad.shift()
            }
        }

        //获取下局龙或下局虎 下三路的状态   bigRoadDisplay[i][j][x]  x =0 路图的值   x =1 和的次数   
        if(getlastValus != true){
            let mp = null
            for(let i = 0; i<bigRoadDisplay.length; i ++ ){
                for(let j = 0; j < bigRoadDisplay[i].length; j ++ ){
                    if(bigRoadDisplay[i][j] ){
                        if(bigRoadDisplay[i][j][0] != null){
                            mp = this.creatorSprite(bigRoadDisplay[i][j][0] == 3 ? 0 : bigRoadDisplay[i][j][0], 1, new cc.Vec2( i * this.daLu.spacing.x, j *  - this.daLu.spacing.y  ), this.daLu.size)
                            if(bigRoadDisplay[i][j][1] != null){
                                this.creatorLabel(mp[0], bigRoadDisplay[i][j][1], 18, new cc.Vec2(0,0))
                            }
                        }else{
                            mp = this.creatorSprite(-1, 1, new cc.Vec2( i * this.daLu.spacing.x, j *  - this.daLu.spacing.y  ), this.daLu.size)
                            
                            this.creatorLabel(mp[0], bigRoadDisplay[i][j][1], 18, new cc.Vec2(0,0))
                        }
                    }
                }
            }
        }

    }

    

    //大眼仔路 小路    蟑螂路
    showRoadMap3(xiaSanLuType:number,getlastValus:boolean = false){
        if(this.bigRoad.length == 0){
            return
        }
        let xiaSanLu = [this.daYanLu, this.xiaoYanLu, this.jiaYouLu]

        let mapList:any[] = []
        let dataList:any[] = []
        let config = this.xiaSanLuConfig[xiaSanLuType]
        let targetInterval =  config.x
       
        let row = -1 //列
        let lastColor = null
        let curColor = null // 2是红色   1 是蓝色
        let displayRow = 0
        let displayCon = 0
        let maxDisplayCon = 0

        for(let i = 0;i<this.bigRoad.length;i++){
           
            for(let j = 0; j<this.bigRoad[i].length;j++){
                curColor = null
                
                if(lastColor == null && (i <config.x || j < config.y) && i <= config.x){
                    continue
                }
                
                if( this.bigRoad[i][j] != null){

                    //路中
                    if(j != 0){
                        if(this.bigRoad[i - targetInterval][j] == null && this.bigRoad[i - targetInterval][j-1] != null){
                            curColor = 1
                        }else{
                            curColor = 2
                        }
                    }else{//路头
                        if(this.bigRoad[i - targetInterval -1] [this.bigRoad[i - 1].length] == null 
                            && this.bigRoad[i - targetInterval -1] [this.bigRoad[i - 1].length -1] != null ){
                                curColor = 2
                        }else{
                            curColor = 1
                        }
                    }
                   
                    if(lastColor != curColor ){//初始化列 和换列
                        
                        maxDisplayCon = this.showMaxHan
                        row = row +1
                        dataList [row] = []
                    }

                    displayRow = (dataList[row].length > maxDisplayCon ? dataList[row].length - maxDisplayCon : 0) + dataList.length -1
                    displayCon = dataList[row].length > maxDisplayCon ? maxDisplayCon : dataList[row].length
                   
                    if(mapList[displayRow] == null){
                        mapList[displayRow] = []
                    }else{
                        while(mapList[displayRow][displayCon] != null ||(lastColor == curColor && dataList[row].length >= this.showMaxHan)){
                            displayCon = displayCon -1
                            displayRow = displayRow +1
                            if(mapList[displayRow] == null){
                                mapList[displayRow] = []
                            }
                           
                            if(mapList[displayRow][displayCon] == null){
                                if(maxDisplayCon == this.showMaxHan){
                                    maxDisplayCon = displayCon
                                }
                                break
                            }
                        }
                    }
                    mapList[displayRow] [ displayCon ] = curColor
                    dataList[row][dataList[row].length] = curColor
                    lastColor = curColor
                }
            }
        }

        //获取下局龙或下局虎 下三路的状态
        if(getlastValus){
            return curColor
        }

        if( mapList.length> xiaSanLu[xiaSanLuType].showMaxRow){
            let needDeleteNum = mapList.length - xiaSanLu[xiaSanLuType].showMaxRow
            for(let i =0;i<needDeleteNum; i++){
                mapList.shift()
                dataList.shift()
            }
        }

        for(let i = 0; i<mapList.length; i ++ ){
            for(let j = 0; j < mapList[i].length; j ++ ){
                this.creatorSprite(mapList[i][j],xiaSanLuType +2,new cc.Vec2( i * xiaSanLu[xiaSanLuType].spacing.x, j * -xiaSanLu[xiaSanLuType].spacing.y  ),xiaSanLu[xiaSanLuType].size )
            }
        }
    }
    
    getByKey(resultData){
        let keyNumber = -1 //0 闲赢 1 庄赢 2 和 3 闲赢闲对 4 闲赢庄对 5 闲赢双对 6 庄赢闲对 7 庄赢庄对 8 庄赢双对 9和 闲对 10 和庄对 11和双对
        if (resultData == null){
            return keyNumber
        }
        switch(resultData.result){
            case 1: //闲赢
                keyNumber = 0
                if (resultData.playerPair && resultData.bankerPair){
                    keyNumber = 5
                }
                else if (resultData.playerPair && !resultData.bankerPair){
                    keyNumber = 3
                }
                else if (!resultData.playerPair && resultData.bankerPair){
                    keyNumber = 4
                }
                break
            case 2: //庄赢
                keyNumber = 1
                if (resultData.playerPair && resultData.bankerPair){
                    keyNumber = 8
                }
                else if (resultData.playerPair && !resultData.bankerPair){
                    keyNumber = 6
                }
                else if (!resultData.playerPair && resultData.bankerPair){
                    keyNumber = 7
                }
                break
            case 3: //和
                keyNumber = 2
                if (resultData.playerPair && resultData.bankerPair){
                    keyNumber = 11
                }
                else if (resultData.playerPair && !resultData.bankerPair){
                    keyNumber = 9
                }
                else if (!resultData.playerPair && resultData.bankerPair){
                    keyNumber = 10
                }
                break
            default:
                break

        }
        return keyNumber
    }

    //获取下局龙或下局虎 下三路的状态
    getForecastState(xiaSanLuType:number, lastLongOrHu){ //  0 和   1 闲家赢 （龙）（蓝）
        this.roadList.push({result:lastLongOrHu})
        this.showRoadMap2(false, this.disposeData(1), true)
        this.roadList.pop()
        
        return this.showRoadMap3(xiaSanLuType, true)
    }

}
